import { CdkStep, CdkStepperModule, CdkStepper } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  QueryList,
  ViewChild,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgStepperModule } from 'angular-ng-stepper';
import { EgButtonComponent } from '../eg-button/eg-button.component';
import { EgFormComponent } from '../eg-form/eg-form.component';

@Component({
  selector: 'eg-stepper',
  standalone: true,
  imports: [
    NgStepperModule,
    CdkStepperModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    EgButtonComponent,
    EgFormComponent,
  ],
  templateUrl: './eg-stepper.component.html',
  styleUrl: './eg-stepper.component.scss',
  providers: [{ provide: CdkStepper }],
})
export class EgStepperComponent {
  @Input() formData: any = [];
  dynamicGroup: any;
  @ViewChild('cdkStepper', { static: true }) cdkStepper: any;
  @ViewChild('formComp', { static: true }) formComp: any;

  @ViewChild(EgFormComponent) formComponent!: EgFormComponent;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.formData?.form?.subforms.changes.subscribe(
      (x: QueryList<CdkStep>) => {}
    );
  }


}
